<template>
  <div>
    <van-tabbar route active-color="#FF2F2F" inactive-color="#333333" @change="changeUrl" z-index="997">
      <van-tabbar-item replace to="/movie/home">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? homeIcon.active : homeIcon.inactive" />
            <span class="f24 mtop8">电影</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/movie/cinema">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? cinemaIcon.active : cinemaIcon.inactive" />
            <span class="f24 mtop8">影院</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="goPoints">
        <template #icon="props">
          <div class="flexbox_column hcenter" style="position: relative">
            <img :src="props.active ? integralIcon.active : integralIcon.inactive" />
            <span class="f24 mtop8">绿色积分</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/movie/order-list">
        <template #icon="props">
          <div class="flexbox_column hcenter" style="position: relative">
            <img :src="props.active ? orderIcon.active : orderIcon.inactive" />

            <span class="f24 mtop8">订单</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/movie/mine">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? mineIcon.active : mineIcon.inactive" />
            <span class="f24 mtop8">我的</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "movieCpn",
  data () {
    return {
      active: 0,
      homeIcon: {
        active: require("@/assets/images/film/home-active.png"),
        inactive: require("@/assets/images/film/home.png"),
      },
      cinemaIcon: {
        active: require("@/assets/images/film/cinema-active.png"),
        inactive: require("@/assets/images/film/cinema.png"),
      },
      orderIcon: {
        active: require("@/assets/images/film/order-active.png"),
        inactive: require("@/assets/images/film/order.png"),
      },
      integralIcon: {
        active: require("@/assets/images/film/integral-active.png"),
        inactive: require("@/assets/images/film/integral.png"),
      },
      mineIcon: {
        active: require("@/assets/images/film/mine-active.png"),
        inactive: require("@/assets/images/film/mine.png"),
      },

      appId: "",
      infos_storage: null,
    }
  },

  computed: {
    ...mapGetters(["cachedViews", "distUserInfo", "getUserConfigInfo"]),
    key () {
      console.log("打印key---->", this.$route.name)
      // return this.$route.meta.activeName
      return this.$route.name
    },
  },
  async created () { },
  methods: {
    changeUrl (data) { },
    goPoints () {
      this.$router.push("/points-mall/home")
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep(.van-tabbar-item__icon img) {
  height: 28px;
  padding-top: 4px;
}

.box {
  padding: 10px 0 15px 0;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99;

  .img {
    width: 30px;
    height: 33px;
  }

  .isIntegral {
    width: 32px;
    height: 32px;
  }

  .name {
    color: #686868;
    font-size: 11px;
  }
}
</style>
